export default function removePropsCurrencyFormat(val) {
  const obj = val;
  for (const prop in obj) {
    if (typeof obj[prop] === 'string') {
      obj[prop] = obj[prop].replace(/[^\d.-]/g, '');
    }
  }
  return obj;
}
